import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useInviteExternalUsersMutation } from "api/enterprisePlanApi";
import { useGetCountriesQuery } from "api/countryApi";
import { showToastSuccess, showToastError } from "components/toastify/ToastNotifications";

interface InviteEmployeeModalProps {
  show: boolean;
  onHide: () => void;
  subdomain: string;
}

export const InviteEmployeeModal: React.FC<InviteEmployeeModalProps> = ({ show, onHide, subdomain }) => {
  const [emails, setEmails] = useState("");
  const [country, setCountry] = useState("");

  const [inviteExternalUsers, { isLoading }] = useInviteExternalUsersMutation();
  const { data: countriesData, isLoading: isCountriesLoading } = useGetCountriesQuery();

  const handleSubmit = async () => {
    if (!emails || !country) {
      showToastError("Please fill all required fields");
      return;
    }

    const emailList = emails.split(",").map((e) => e.trim()).filter((e) => e);
    const invites = emailList.map((email) => ({
      Email: email,
      Application: "Joble",
      Country: country,
    }));

    try {
      await inviteExternalUsers({ invites, resendInvite: false, subdomain }).unwrap();
      showToastSuccess("Invites sent successfully");
      onHide();
    } catch (err) {
      showToastError("Failed to send invites");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Invite Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Email (comma separated for multiple)</Form.Label>
          <Form.Control
            type="text"
            placeholder="example@mail.com"
            value={emails}
            onChange={(e) => setEmails(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Country</Form.Label>
          <Form.Select value={country} onChange={(e) => setCountry(e.target.value)} disabled={isCountriesLoading}>
            <option value="">Select country...</option>
            {countriesData?.data?.map((c: any) => (
              <option key={c.id} value={c.country}>
                {c.country}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading} className="w-100">
          {isLoading ? "Sending..." : "Send Invite"}
        </Button>
      </Modal.Body>
    </Modal>
  );
};
